/* eslint-disable max-len */
import React from 'react';
import { string } from 'prop-types';

const DropzoneArrowIcon = ({ type }) => (
  <div className={`arrow-${type}`}>
    <svg xmlns="http://www.w3.org/2000/svg" width="29" height="52" viewBox="0 0 29 52" fill="none">
      <g opacity="0.75">
        <path d="M14.5 51.8903L1.94263 30.2317L27.0574 30.2317L14.5 51.8903Z" fill="white" />
        <rect x="10.875" y="8.57312" width="7.70312" height="21.6585" fill="white" />
        <rect x="10.875" y="4.96338" width="7.70312" height="2.2561" fill="white" />
        <rect x="10.875" y="2.2561" width="7.70312" height="1.35366" fill="white" />
        <rect x="10.875" width="7.70312" height="0.902439" fill="white" />
      </g>
    </svg>
  </div>
);

DropzoneArrowIcon.propTypes = {
  type: string,
};

DropzoneArrowIcon.defaultProps = {
  type: null,
};

export default DropzoneArrowIcon;
